import { DeviceInformationResolverActions, DeviceInformationApiActions } from './device-information.actions';
import { Injectable } from '@angular/core';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
@Injectable()
export class DeviceInformationEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  deviceInformationRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DeviceInformationResolverActions.deviceRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getAppleDeviceInformation(udid, '2.0'),
          (deviceInformation) =>
            DeviceInformationApiActions.deviceLoaded({
              deviceInformation: {
                ...deviceInformation,
                udid: udid,
              },
            }),
          (error) => DeviceInformationApiActions.deviceLoadedError({ error })
        )
      )
    );
  });
}
